import {
  Dialog,
  DialogTitle,
  DialogActions,
  Box,
  Grid,
  Paper,
  Typography,
} from '@mui/material'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { metodoPrograma } from '../../../../components/api'

import { makeStyles } from '@mui/styles'
import { GlobalContext } from '../../../../App'

const useStyles = makeStyles((theme) => ({
  paperButton: {
    padding: theme.spacing(2),
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))

const ModalSelecionaPontoVenda = ({ open, onClose }) => {
  const { dispatch } = useContext(GlobalContext)

  const classes = useStyles()
  const [listaPontoVenda, setListaPontoVenda] = useState([])
  const [qtdPontos, setQtdPonto] = useState(0)

  const handleTrue = (id) => {
    dispatch({ field: 'lojaPontoVenda', value: { idPontoVenda: id } })
    onClose(id, qtdPontos)
  }

  const handleFalse = () => {
    onClose(null)
  }
  const buscaPontosDeVenda = useCallback(async () => {
    const { result } = await metodoPrograma(
      'buscaPontoVendaUsuario',
      {},
      'CtrlPontoVenda',
    )

    if (result?.length === 1) {
      dispatch({
        field: 'lojaPontoVenda',
        value: { idPontoVenda: result[0].idPontoVenda },
      })
      onClose(result[0].idPontoVenda, 1)
    } else {
      setQtdPonto(result?.length)
    }

    setListaPontoVenda(result)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    buscaPontosDeVenda()
  }, [buscaPontosDeVenda])
  return (
    <Dialog maxWidth="lg" open={open} onClose={handleFalse}>
      {listaPontoVenda && <DialogTitle>Selecione Ponto de Venda</DialogTitle>}
      <DialogActions>
        {listaPontoVenda ? (
          <Grid container spacing={2}>
            {listaPontoVenda?.map(({ dsPontoVenda, idPontoVenda }) => (
              <Grid key={idPontoVenda} item xs={12}>
                <Paper
                  className={classes.paperButton}
                  onClick={() => handleTrue(idPontoVenda)}
                  role="button"
                  tabIndex={0}
                >
                  <Typography>{dsPontoVenda}</Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Typography variant="h3" style={{ fontSize: '2rem', margin: 10 }}>
              Usurário sem Ponto de venda Vinculado
            </Typography>
          </Box>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default ModalSelecionaPontoVenda
